import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from "@headlessui/react";
function WPQTTabs({ tabs, tabsContent }) {
    return (_jsxs(TabGroup, { children: [_jsx(TabList, { className: "wpqt-mb-6 wpqt-flex wpqt-border-0 wpqt-border-b wpqt-border-solid wpqt-border-b-gray-300", children: tabs.map((tab) => (_jsx(WPQTTab, { children: tab }, tab))) }), _jsx(TabPanels, { children: tabsContent.map((tabContent, index) => (_jsx(WPQTTabPanel, { children: tabContent }, index))) })] }));
}
function WPQTTab({ children }) {
    return (_jsx(Tab, { as: "div", className: "wpqt-flex-1 wpqt-cursor-pointer wpqt-p-1 wpqt-pb-[10px] wpqt-text-center wpqt-text-lg data-[selected]:wpqt-border-b-2 data-[selected]:wpqt-border-l-0 data-[selected]:wpqt-border-r-0 data-[selected]:wpqt-border-t-0 data-[selected]:wpqt-border-solid data-[selected]:wpqt-border-b-blue-500", children: children }));
}
function WPQTTabPanel({ children }) {
    return _jsx(TabPanel, { children: children });
}
export { WPQTTabs };
